import http from '../../utils/fetch';
import updownfile from "../../utils/updownfile";
export default {

    baseurl:'/api/swyl/v1/formulanew/rateFormulaRenew',

    gongshigaishu:'/api/swyl/v1/neixiaogaishugongshi/rateFormulaRenewNeixiaogaishu',

    rateFormulaParam:'/api/swyl/v1/formulanew/rateFormulaParam',

    pro:'/api/swyl/v1/xiangmu/proProductInfo',

    allvw:'/api/swyl/v1/allmaterialvw/viewMaterialAllvw',

    guocheng:'/api/swyl/v1/renewver/rateFormulaRenewVer',

    rateSunyicaozuobiao:'/api/swyl/v1/sunyicaozuobiao/rateSunyicaozuobiao',

    proMain:'/api/swyl/v1/xiangmu/proMain',


    //新-测算版本列表视图版
    rvlistshowPage(q){
        return http({
            url: '/api/swyl/v1/demo/viewRateFormulaList/selectPage',
            method: 'post',
            params: q
        });
    },
    /*rvlistshowPage(q){
        return http({
            url: this.guocheng+'/selectPage',
            method: 'post',
            params: q
        });
    },*/
    chehui(q){
        return http({
            url: '/api/swyl/v1/formulanew/rateFormulaRenew/chehui',
            method: 'post',
            params: q
        });
    },
    deleteH(q){
        return http({
            url: this.guocheng+'/deleteBybanbenId',
            method: 'post',
            params:q
        });
    },

    chufatejiashenpi(q) {
        return http({
            url: this.baseurl+'/chufatejiashenpi',
            method: 'post',
            params:q
        });
    },

    caozuobiaoselectPage(query){
        return http({
            url: this.rateSunyicaozuobiao+'/selectPage',
            method: 'post',
            params: query
        });
    },

    gongshijichuselectPage(query){
        return http({
            url: this.baseurl+'/gongshiselectPage',
            method: 'post',
            params: query
        });
    },

    gongshineixiaogaishuselectPage(query){
        return http({
            url: this.gongshigaishu+'/gongshiselectPage',
            method: 'post',
            params: query
        });
    },


    gaishugongshiselectList(query){
        return http({
            url: this.gongshigaishu+'/selectList',
            method: 'post',
            params: query
        });
    },


    gongshijichuupdate(query){
        return http.post(this.baseurl+'/updateById', query);
    },

    gongshineixiaogaishuupdate(query){
        return http.post(this.gongshigaishu+'/updateById', query);
    },


    proMainselectById(id){
        return http({
            url: this.proMain+'/userselectById',
            method: 'post',
            params: {"id":id}
        });
    },


    getAllRate(jsonObject){
        return http.post(this.baseurl+'/getAllRate',jsonObject);
    },

    getAllRateByChanPin(q){
        return http.post(this.baseurl+'/getAllRateByChanPin',q);
    },

    getAllRateByChanPincaiwuzancun(q){
        return http.post(this.baseurl+'/getAllRateByChanPincaiwuzancun',q);
    },

    getbanben(q){
        return http({
            url: this.baseurl+'/cesuanbanben',
            method: 'post',
            params: q
        });
    },

    getbyformula(q){
        return http.post(this.baseurl+'/getbyformula',q);
    },

    caiwugaishu(q){
        return http.post(this.baseurl+'/caiwugaishuneixiao',q);
    },

    selectList(q){
        return http({
            url: this.pro+'/selectList',
            method: 'post',
            params: q
        });
    },

    allvwselectList(query){
        return http({
            url: this.allvw+'/selectList',
            method: 'post',
            params: query
        });
    },


    findguocheng(q){
        return http({
            url: this.baseurl+'/findguocheng',
            method: 'post',
            params: q
        });
    },

    gongshibiaolist(q){
        return http({
            url: this.baseurl+'/parList',
            method: 'post',
            params: q
        });
    },


    findguochengHaiwai(q){
        return http({
            url: this.baseurl+'/findguochengHaiwai',
            method: 'post',
            params: q
        });
    },

    findcaiwuzancun(q){
        return http({
            url: this.baseurl+'/findcaiwuzancun',
            method: 'post',
            params: q
        });
    },

    getjisuanjilu(q){
        return http({
            url: this.baseurl+'/getjisuanjilu',
            method: 'post',
            params: q
        });
    },

    getjisuanjilucaiwuzancun(q){
        return http({
            url: this.baseurl+'/getjisuanjilucaiwuzancun',
            method: 'post',
            params: q
        });
    },

    finddanbaocun(q){
        return http({
            url: this.baseurl+'/finddanbaocun',
            method: 'post',
            params: q
        });
    },

    getjisuanjiluneixiao(q){
        return http({
            url: this.baseurl+'/getjisuanjiluneixiao',
            method: 'post',
            params: q
        });
    },

    luojishanchu(q){
        return http({
            url: this.guocheng+'/luojishanchu',
            method: 'post',
            params: q
        });
    },


    overhaiwaiyinglishenpi(q){
        return http({
            url: this.baseurl+'/overhaiwaiyinglishenpi',
            method: 'post',
            params: q
        });
    },

	fanzhuanop(q){
	    return http({
	        url: this.baseurl+'/fanzhuanop',
	        method: 'post',
	        params: q
	    });
	},

    haiwaidangengxin(q){
        return http.post(this.baseurl+'/haiwaidangengxin',q);
    },

    downloadExcel(c){

        updownfile.down(this.rateSunyicaozuobiao+'/downloadExcel',c,"post",'data');

    },

    rvlistshowdownloadExcel(c){

        updownfile.down(this.guocheng+'/downloadExcel',c,"post",'data');

    },

    gongshidownloadExcel(c){

        updownfile.down(this.baseurl+'/downloadExcel',c,"post",'data');

    },

    gongshigaidownloadExcel(c){

        updownfile.down(this.gongshigaishu+'/downloadExcel',c,"post",'data');

    },

    caozuobiaoupdateById(query){
        return http({
            url: this.rateSunyicaozuobiao+'/updateById',
            method: 'post',
            params: query
        });
    },


    xinzengsunyi(query){
        return http({
            url: this.rateSunyicaozuobiao+'/insert',
            method: 'post',
            params: query
        });
    },


    sunyiluojishanchu(query){
        return http({
            url: this.rateSunyicaozuobiao+'/luojishanchu',
            method: 'post',
            params: query
        });
    },
    ifguonei(v){
        return http.post('/api/bscUserInfoAgentBasic/ifguonei?usercode='+v);
    },

    searchCaiwuShpStatus(q) {
        return http({
            url: this.baseurl+'/checkCaiwuShpStatus',
            method: 'post',
            params:q
        });
    },
    searchNxCaiwuShpStatus(q) {
        return http({
            url: this.baseurl+'/checkNxCaiwuShpStatus',
            method: 'post',
            params:q
        });
    },

    getOldRversion(rversion){
        return http.post('/api/swyl/v1/formulanew/rateFormulaRenew/getOldRversion?rversion='+rversion);
    },

}
